import { Injectable } from '@angular/core';
import { EnumItem } from 'beyond-util/src/app/shared/services/list.service';

@Injectable()
export class IzvestajSettings {
  public prihodiPoEmisijamaTableSettings = {
    additable: false,
    title: 'Izveštaj o prihodu po emisijama',
    type: 'main',
    _id: '1801848365',
    allFields: [
      {
        additable: false,
        dbType: 'integer',
        editable: false,
        fieldKey: 'sifraEmisije',
        id: '20',
        label: 'Šifra emisije',
        mandatory: false,
        name: 'sifraEmisije',
        type: 'input',
        width: 120,
      },
      {
        additable: false,
        dbType: 'varchar(100)',
        editable: false,
        fieldKey: 'nazivEmisije',
        id: '21',
        label: 'Naziv emisije',
        mandatory: false,
        name: 'nazivEmisije',
        type: 'input',
        width: 120,
      },
      {
        additable: false,
        dbType: 'integer',
        editable: false,
        fieldKey: 'prihodPoEmisiji',
        id: '22',
        label: 'Prihod po emisiji',
        mandatory: false,
        name: 'prihodPoEmisiji',
        type: 'input',
        width: 120,
      },
      {
        additable: false,
        dbType: 'nvarchar(100)',
        editable: false,
        fieldKey: 'strukturaPrihoda',
        id: '23',
        label: 'Struktura prihoda',
        mandatory: false,
        name: 'strukturaPrihoda',
        type: 'input',
        width: 120,
      },
    ],
    filterFields: [],
    completerMainAndSecond: false,
    deletable: false,
    documentType: 'izvestaj',
    editable: false,
    fetchObject: 'basic',
    formCode: 'M3_RPT1',
    formSettings: {
      table: ['20', '21', '22', '23'],
    },
    group: 'izvestajPrihodaPoEmisijama',
    inlineAdding: false,
    inlineEditing: false,
    lazyListSource: 'mainAndSecond',
    name: 'Main',
    relations: [],
  };

  public prihodiPoEmisijamaTableData = {
    korisnickoIme: 'admin',
    parts: {
      Korisnik: 'admin',
      action: 'getIzvestajPrihodaPoEmisijama',
      documentID: 'izvestajPrihodaPoEmisijama',
      documentId: 'izvestajPrihodaPoEmisijama',
      korisnik: 'admin',
      izvestajPrihodaPoEmisijama: [
        {
          sifraEmisije: '1011',
          nazivEmisije: 'Emisija 1',
          prihodPoEmisiji: 10000,
          strukturaPrihoda: 'Lorem ipsum dolor',
        },
        {
          sifraEmisije: '1012',
          nazivEmisije: 'Emisija 2',
          prihodPoEmisiji: 10000,
          strukturaPrihoda: 'Lorem ipsum dolor',
        },
        {
          sifraEmisije: '1011',
          nazivEmisije: 'Emisija 1',
          prihodPoEmisiji: 10000,
          strukturaPrihoda: 'Lorem ipsum dolor',
        },
        {
          sifraEmisije: '1012',
          nazivEmisije: 'Emisija 2',
          prihodPoEmisiji: 10000,
          strukturaPrihoda: 'Lorem ipsum dolor',
        },
        {
          sifraEmisije: '1011',
          nazivEmisije: 'Emisija 1',
          prihodPoEmisiji: 10000,
          strukturaPrihoda: 'Lorem ipsum dolor',
        },
        {
          sifraEmisije: '1012',
          nazivEmisije: 'Emisija 2',
          prihodPoEmisiji: 10000,
          strukturaPrihoda: 'Lorem ipsum dolor',
        },
        {
          sifraEmisije: '1011',
          nazivEmisije: 'Emisija 1',
          prihodPoEmisiji: 10000,
          strukturaPrihoda: 'Lorem ipsum dolor',
        },
        {
          sifraEmisije: '1012',
          nazivEmisije: 'Emisija 2',
          prihodPoEmisiji: 10000,
          strukturaPrihoda: 'Lorem ipsum dolor',
        },
        {
          sifraEmisije: '1011',
          nazivEmisije: 'Emisija 1',
          prihodPoEmisiji: 10000,
          strukturaPrihoda: 'Lorem ipsum dolor',
        },
        {
          sifraEmisije: '1012',
          nazivEmisije: 'Emisija 2',
          prihodPoEmisiji: 10000,
          strukturaPrihoda: 'Lorem ipsum dolor',
        },
        {
          sifraEmisije: '1011',
          nazivEmisije: 'Emisija 1',
          prihodPoEmisiji: 10000,
          strukturaPrihoda: 'Lorem ipsum dolor',
        },
        {
          sifraEmisije: '1012',
          nazivEmisije: 'Emisija 2',
          prihodPoEmisiji: 10000,
          strukturaPrihoda: 'Lorem ipsum dolor',
        },
        {
          sifraEmisije: '1011',
          nazivEmisije: 'Emisija 1',
          prihodPoEmisiji: 10000,
          strukturaPrihoda: 'Lorem ipsum dolor',
        },
        {
          sifraEmisije: '1012',
          nazivEmisije: 'Emisija 2',
          prihodPoEmisiji: 10000,
          strukturaPrihoda: 'Lorem ipsum dolor',
        },
        {
          sifraEmisije: '1012',
          nazivEmisije: 'Emisija 2',
          prihodPoEmisiji: 10000,
          strukturaPrihoda: 'Lorem ipsum dolor',
        },
        {
          sifraEmisije: '1012',
          nazivEmisije: 'Emisija 2',
          prihodPoEmisiji: 10000,
          strukturaPrihoda: 'Lorem ipsum dolor',
        },
        {
          sifraEmisije: '1012',
          nazivEmisije: 'Emisija 2',
          prihodPoEmisiji: 10000,
          strukturaPrihoda: 'Lorem ipsum dolor',
        },
        {
          sifraEmisije: '1012',
          nazivEmisije: 'Emisija 2',
          prihodPoEmisiji: 10000,
          strukturaPrihoda: 'Lorem ipsum dolor',
        },
      ],
    },
  };

  public prihodiPoEmisijamaHeaderSettings = {
    _id: '1555917011',
    title: 'Pregled klijenata',
    group: 'PravnoLice',
    deletable: 'true',
    documentType: 'Sifarnik',
    fetchObject: 'basic',
    lazyListSource: 'mainAndSecond',
    fromCode: 'MSKLI_PL',
    idProperty: '',
    completerMainField: '',
    completerSecondField: '',
    completerMainAndSecond: 'true',
    name: 'Pregledklijenata',
    type: 'pregledklijenata',
    editable: 'true',
    additable: 'true',
    inlineAdding: 'true',
    inlineEditing: 'false',
    allFields: [
      {
        id: '1',
        name: 'datumEmitovanja',
        fieldKey: 'datumEmitovanja',
        label: 'Datum emitovanja',
        type: 'date',
        editable: 'true',
        additable: 'true',
        mandatory: 'true',
        width: 10,
        dbType: 'DATE',
      },
      {
        id: '2',
        name: 'program',
        fieldKey: 'program',
        label: 'Program',
        type: 'input',
        multiline: 'true',
        editable: 'true',
        additable: 'true',
        mandatory: 'true',
        width: 10,
        dbType: 'VARCHAR(50)',
      },
      {
        id: '3',
        name: 'cenaKostanjaEmisije',
        fieldKey: 'cenaKostanjaEmisije',
        label: 'Cena koštanja emisije',
        type: 'input',
        editable: 'true',
        additable: 'true',
        mandatory: 'true',
        width: 10,
        dbType: 'VARCHAR(50)',
      },
      {
        id: '4',
        name: 'trajanje',
        fieldKey: 'trajanje',
        label: 'Trajanje emisije',
        type: 'input',
        editable: 'true',
        additable: 'true',
        mandatory: 'true',
        width: 10,
        dbType: 'VARCHAR(50)',
      },
      {
        id: '5',
        name: 'nacinEmitovanja',
        fieldKey: 'nacinEmitovanja',
        label: 'Način emitovanja',
        type: 'input',
        editable: 'true',
        additable: 'true',
        mandatory: 'true',
        width: 10,
        dbType: 'VARCHAR(50)',
      },
      {
        id: '6',
        name: 'ukupanPrihodZaPeriod',
        fieldKey: 'ukupanPrihodZaPeriod',
        label: 'Ukupan prihod',
        type: 'input',
        editable: 'true',
        additable: 'true',
        mandatory: 'true',
        width: 10,
        dbType: 'DECIMAL',
      },
      {
        id: '7',
        name: 'strukturaPrihoda',
        fieldKey: 'strukturaPrihoda',
        label: 'Struktura prihoda',
        type: 'input',
        editable: 'true',
        additable: 'true',
        mandatory: 'true',
        width: 10,
        dbType: 'VARCHAR(50)',
      },
      {
        id: '8',
        name: 'opis',
        fieldKey: 'opis',
        label: 'Opis',
        multiline: 'true',
        height: 3,
        type: 'input',
        editable: 'true',
        additable: 'true',
        mandatory: 'true',
        width: 10,
        dbType: 'VARCHAR(50)',
      },
    ],
    filterFields: [],
    formSettings: {
      header: [
        {
          title: 'Podaci',
          panels: [
            {
              title: 'Panel 1',
              panelVisible: 'false',
              expanded: 'true',
              controls: [
                ['1', '2', '3', '4'],
                ['5', '6', '7', '8'],
              ],
            },
          ],
        },
      ],
    },
  };

  public headerData = {
    datumEmitovanja: '2019-02-03',
    program: 'RTS1',
    cenaKostanjaEmisije: 1230,
    trajanje: '154',
    nacinEmitovanja: 'Televizor',
    ukupanPrihodZaPeriod: 1251,
    strukturaPrihoda: 'nzm',
    opis: 'Neki izvestaj',
  };

  public headerSettingsDnevniPlan = {
    _id: '1555917011',
    title: 'Pregled klijenata',
    group: 'PravnoLice',
    deletable: 'true',
    documentType: 'Sifarnik',
    fetchObject: 'basic',
    lazyListSource: 'mainAndSecond',
    fromCode: 'MSKLI_PL',
    idProperty: '',
    completerMainField: '',
    completerSecondField: '',
    completerMainAndSecond: 'true',
    name: 'Pregledklijenata',
    type: 'pregledklijenata',
    editable: 'true',
    additable: 'true',
    inlineAdding: 'true',
    inlineEditing: 'false',
    allFields: [
      {
        id: '1',
        name: 'datum',
        fieldKey: 'datum',
        label: 'Datum',
        type: 'date',
        editable: 'true',
        additable: 'true',
        mandatory: 'true',
        width: 10,
        dbType: 'DATE',
      },
      {
        additable: true,
        dbType: 'VARCHAR(25)',
        default: true,
        editable: true,
        fieldKey: 'Klijent',
        entityType: 'Klijent',
        id: '2',
        label: 'Klijent',
        lookupFormCode: 'MSKLI_KLI',
        lookupFormName: 'Pregled klijenata',
        mandatory: true,
        name: 'Klijent',
        path: null,
        type: 'completer',
        width: 10,
      },
    ],
    filterFields: [],
    formSettings: {
      header: [
        {
          title: 'Podaci',
          panels: [
            {
              title: 'Klijent',
              panelVisible: true,
              expanded: 'true',
              controls: [['1'], ['2']],
            },
          ],
        },
      ],
    },
    relations: [this.getKupciSettings()],
  };

  public dnevniPlanEmitovanjaZaKupcaTableSettings = {
    additable: false,
    title: 'Dnevni plan emitovanja za kupca',
    type: 'main',
    _id: '1801848365',
    allFields: [
      {
        additable: false,
        dbType: 'VARCHAR(10)',
        editable: false,
        fieldKey: 'SpotNaziv',
        id: '20',
        label: 'Naziv spota',
        mandatory: false,
        name: 'SpotNaziv',
        type: 'input',
        width: 120,
      },
      {
        additable: false,
        dbType: 'varchar(100)',
        editable: false,
        fieldKey: 'EmisijaNaziv',
        id: '21',
        label: 'Naziv emisije',
        mandatory: false,
        name: 'EmisijaNaziv',
        type: 'input',
        width: 120,
      },
      {
        additable: false,
        dbType: 'integer',
        editable: false,
        fieldKey: 'Trajanje',
        id: '22',
        label: 'Trajanje spota',
        mandatory: false,
        name: 'Trajanje',
        type: 'input',
        width: 120,
      },
      {
        additable: false,
        dbType: 'nvarchar(100)',
        editable: false,
        fieldKey: 'ProgramNaziv',
        id: '23',
        label: 'Program',
        mandatory: false,
        name: 'ProgramNaziv',
        type: 'input',
        width: 120,
      },
    ],
    filterFields: [],
    completerMainAndSecond: false,
    deletable: false,
    documentType: 'izvestaj',
    editable: false,
    fetchObject: 'basic',
    formCode: 'M3_RPT2',
    formSettings: {
      table: ['20', '21', '22', '23'],
    },
    group: 'dnevniPlanEmitovanjaZaKupca',
    inlineAdding: false,
    inlineEditing: false,
    lazyListSource: 'mainAndSecond',
    name: 'Main',
    relations: [],
  };

  public getKupciSettings() {
    return {
      additable: true,
      allFields: [
        {
          additable: true,
          dbType: 'VARCHAR(25)',
          default: true,
          editable: false,
          fieldKey: 'Klijent',
          entityType: 'Klijent',
          id: '111-111-111',
          label: 'Klijent',
          lookupFormCode: 'MSKLI_KLI',
          lookupFormName: 'Pregled klijenata',
          mandatory: false,
          name: 'Klijent',
          path: null,
          type: 'completer',
          width: 10,
        },
      ],
      completerMainAndSecond: true,
      completerMainField: 'PIBVATJMBG',
      completerSecondField: 'NazivImePrezime',
      deletable: true,
      details: [],
      documentType: 'Sifarnik',
      editable: true,
      fetchObject: 'basic',
      filterFields: [],
      formSettings: {
        header: [
          {
            title: 'Podaci',
            panels: [
              {
                title: 'Panel 1',
                panelVisible: false,
                expanded: true,
                controls: [[], []],
              },
            ],
          },
        ],
        table: [],
        lookupTable: ['111-111-111'],
      },
      fromCode: 'MSKLI_KLI',
      group: 'Klijent',
      idProperty: 'Id',
      inlineAdding: true,
      inlineEditing: true,
      lazyListSource: 'mainAndSecond',
      name: 'Klijent',
      relations: [],
      title: 'Klijent',
      type: 'Klijent',
      _id: '51073157',
    };
  }

  public getEmisijeSettings() {
    return {
      additable: true,
      allFields: [
        {
          additable: true,
          dbType: 'VARCHAR(25)',
          default: true,
          editable: false,
          fieldKey: 'Emisija',
          entityType: 'Emisija',
          id: '111-111-111',
          label: 'Klijent',
          lookupFormCode: 'MSKLI_KLI',
          lookupFormName: 'Pregled emisija',
          mandatory: false,
          name: 'Emsisija',
          path: null,
          type: 'completer',
          width: 10,
        },
      ],
      completerMainAndSecond: true,
      completerMainField: 'Sifra',
      completerSecondField: 'Naziv',
      deletable: true,
      details: [],
      documentType: 'Sifarnik',
      editable: true,
      fetchObject: 'basic',
      filterFields: [],
      formSettings: {
        header: [
          {
            title: 'Podaci',
            panels: [
              {
                title: 'Panel 1',
                panelVisible: false,
                expanded: true,
                controls: [[], []],
              },
            ],
          },
        ],
        table: [],
        lookupTable: ['111-111-111'],
      },
      fromCode: 'MSEMI_EMI',
      group: 'Emisija',
      idProperty: 'Id',
      inlineAdding: true,
      inlineEditing: true,
      lazyListSource: 'mainAndSecond',
      name: 'Emisija',
      relations: [],
      title: 'Emisija',
      type: 'Emisija',
      _id: '51073157',
    };
  }

  // tslint:disable-next-line: member-ordering
  public dnevniPlanEmitovanjaHeaderSettings = {
    _id: '1555917011',
    title: 'Pregled klijenata',
    group: 'PravnoLice',
    deletable: 'true',
    documentType: 'Sifarnik',
    fetchObject: 'basic',
    lazyListSource: 'mainAndSecond',
    fromCode: 'MSKLI_PL',
    idProperty: '',
    completerMainField: '',
    completerSecondField: '',
    completerMainAndSecond: false,
    name: 'Pregledklijenata',
    type: 'pregledklijenata',
    editable: true,
    additable: true,
    inlineAdding: true,
    inlineEditing: false,
    allFields: [
      {
        id: '1',
        name: 'datum',
        fieldKey: 'datum',
        label: 'Datum',
        type: 'date',
        editable: true,
        additable: true,
        mandatory: true,
        width: 10,
        dbType: 'DATE',
      },
      {
        id: '2',
        name: 'program',
        fieldKey: 'program',
        label: 'Program',
        type: 'comboFixed',
        entityType: 'MSEMI_EMI_ProgramIdEnum',
        editable: true,
        additable: true,
        mandatory: true,
        width: 10,
      },
      {
        additable: true,
        dbType: 'VARCHAR(25)',
        default: true,
        editable: true,
        fieldKey: 'Emisija',
        entityType: 'Emisija',
        id: '3',
        label: 'Emisija',
        lookupFormCode: 'MSEMI_EMIDPE',
        lookupFormName: 'Pregled emisija',
        mandatory: false,
        name: 'Emisija',
        path: null,
        type: 'completer',
        width: 10,
      },
      {
        additable: true,
        dbType: 'VARCHAR(25)',
        default: true,
        editable: true,
        fieldKey: 'Klijent',
        entityType: 'Klijent',
        id: '4',
        label: 'Klijent',
        lookupFormCode: 'MSKLI_KLIIDS',
        lookupFormName: 'Pregled klijenata',
        mandatory: false,
        name: 'Klijent',
        path: null,
        type: 'completer',
        width: 100,
      },
    ],
    filterFields: [],
    formSettings: {
      header: [
        {
          title: 'Podaci',
          panels: [
            {
              title: 'Klijent',
              panelVisible: true,
              expanded: true,
              controls: [
                ['1', '3'],
                ['2', '4'],
              ],
            },
          ],
        },
      ],
    },
    relations: [this.getEmisijeSettings(), this.getKupciSettings()],
  };

  // tslint:disable-next-line: member-ordering
  public dnevniPlanEmitovanjaTableSettings = {
    additable: false,
    title: 'Dnevni plan emitovanja',
    type: 'main',
    _id: '1801848365',
    allFields: [
      {
        additable: false,
        dbType: 'NVARCHAR',
        editable: false,
        fieldKey: 'rbr',
        id: '20',
        label: '#',
        mandatory: false,
        name: 'rbr',
        type: 'input',
        width: 100,
        sortable: false,
      },
      {
        additable: false,
        dbType: 'NVARCHAR',
        editable: false,
        fieldKey: 'AgencijaNaziv',
        id: '21',
        label: 'Agencija',
        mandatory: false,
        name: 'AgencijaNaziv',
        type: 'input',
        width: 100,
        sortable: true,
      },
      {
        additable: false,
        dbType: 'NVARCHAR(50)',
        editable: false,
        fieldKey: 'KupacNaziv',
        id: '22',
        label: 'Klijent',
        mandatory: false,
        name: 'KupacNaziv',
        type: 'input',
        width: 100,
        sortable: true,
      },
      {
        name: 'EmisijaNaziv',
        fieldKey: 'EmisijaNaziv',
        label: 'Emisija',
        id: '23',
        type: 'input',
        editable: false,
        additable: true,
        mandatory: false,
        path: null,
        width: 100,
        dbType: 'VARCHAR(25)',
        default: true,
        sortable: true,
      },
      {
        name: 'VremeEmitovanja',
        fieldKey: 'VremeEmitovanja',
        label: 'Vreme emitovanja',
        type: 'input',
        id: '24',
        editable: false,
        additable: false,
        mandatory: false,
        width: 100,
        dbType: 'VARCHAR(50)',
        default: true,
        sortable: true,
      },
      {
        additable: false,
        dbType: 'varchar(100)',
        editable: false,
        fieldKey: 'SpotSifra',
        id: '25',
        label: 'Šifra spota',
        mandatory: false,
        name: 'SpotSifra',
        type: 'input',
        width: 100,
        sortable: true,
      },
      {
        additable: false,
        dbType: 'varchar(100)',
        editable: false,
        fieldKey: 'SpotNaziv',
        id: '26',
        label: 'Naziv spota',
        mandatory: false,
        name: 'SpotNaziv',
        type: 'input',
        width: 100,
        sortable: true,
      },
      {
        additable: false,
        dbType: 'nvarchar(100)',
        editable: false,
        fieldKey: 'Trajanje',
        id: '27',
        label: 'Trajanje spota (s)',
        mandatory: false,
        name: 'Trajanje',
        type: 'input',
        width: 100,
        sortable: true,
      },
      {
        additable: false,
        dbType: 'nvarchar(100)',
        editable: false,
        fieldKey: 'VremeTrajanjaServer',
        id: '28',
        label: 'Trajanje server',
        mandatory: false,
        name: 'VremeTrajanjaServer',
        type: 'input',
        width: 100,
        sortable: true,
      },
      // {
      //   additable: false,
      //   dbType: 'nvarchar(100)',
      //   editable: false,
      //   fieldKey: 'ZbirniRedTrajanja',
      //   id: '26',
      //   label: 'Zbirni red trajanja(s)',
      //   mandatory: false,
      //   name: 'ZbirniRedTrajanja',
      //   type: 'input',
      //   width: 100,
      // },
    ],
    filterFields: [],
    completerMainAndSecond: false,
    deletable: false,
    documentType: 'izvestaj',
    editable: false,
    fetchObject: 'basic',
    formCode: 'M3_RPT1',
    formSettings: {
      table: ['20', '21', '22', '23', '24', '25', '26', '27', '28'],
    },
    group: 'izvestajPrihodaPoEmisijama',
    inlineAdding: false,
    inlineEditing: false,
    lazyListSource: 'mainAndSecond',
    name: 'Main',
    relations: [],
  };

  // tslint:disable-next-line: member-ordering
  public izvestajZaSokojTableSettings = {
    additable: false,
    title: 'Izvestaj za SOKOJ',
    type: 'main',
    _id: '213132332',
    allFields: [
      {
        additable: false,
        dbType: 'DATE',
        editable: false,
        fieldKey: 'DatumEmitovanja',
        id: '20',
        label: 'Datum emitovanja',
        mandatory: false,
        name: 'DatumEmitovanja',
        type: 'date',
        width: 120,
      },
      {
        additable: false,
        dbType: 'VARCHAR(10)',
        editable: false,
        fieldKey: 'VremeEmitovanja',
        id: '21',
        label: 'Vreme emitovanja',
        mandatory: false,
        name: 'VremeEmitovanja',
        type: 'input',
        width: 120,
      },
      {
        additable: false,
        dbType: 'VARCHAR(100)',
        editable: false,
        fieldKey: 'EmisijaNaziv',
        id: '22',
        label: 'Naziv emisije',
        mandatory: false,
        name: 'EmisijaNaziv',
        type: 'input',
        width: 120,
      },
      {
        additable: false,
        dbType: 'VARCHAR(100)',
        editable: false,
        fieldKey: 'Izvodjac',
        id: '23',
        label: 'Izvođač',
        mandatory: false,
        name: 'Izvodjac',
        type: 'input',
        width: 120,
      },
      {
        additable: false,
        dbType: 'VARCHAR(100)',
        editable: false,
        fieldKey: 'NazivDela',
        id: '24',
        label: 'Naziv dela',
        mandatory: false,
        name: 'NazivDela',
        type: 'input',
        width: 120,
      },
      {
        additable: false,
        dbType: 'VARCHAR(100)',
        editable: false,
        fieldKey: 'Autor',
        id: '25',
        label: 'Autori',
        mandatory: false,
        name: 'Autor',
        type: 'input',
        width: 120,
      },
      {
        additable: false,
        dbType: 'integer',
        editable: false,
        fieldKey: 'Trajanje',
        id: '26',
        label: 'Trajanje dela',
        mandatory: false,
        name: 'Trajanje',
        type: 'input',
        width: 120,
      },
      {
        additable: false,
        dbType: 'VARCHAR(50)',
        editable: false,
        fieldKey: 'NacinUpotrebe',
        id: '27',
        label: 'Način upotrebe / izvođenja dela',
        mandatory: false,
        name: 'NacinUpotrebe',
        type: 'input',
        width: 120,
      },
      {
        additable: false,
        dbType: 'NVARCHAR(20)',
        editable: false,
        fieldKey: 'Program',
        id: '28',
        label: 'Program',
        mandatory: false,
        name: 'Program',
        type: 'input',
        width: 120,
      },
    ],
    filterFields: [],
    completerMainAndSecond: false,
    deletable: false,
    documentType: 'izvestaj',
    editable: false,
    fetchObject: 'basic',
    formCode: 'M3_RPT2',
    formSettings: {
      table: ['20', '21', '22', '23', '24', '25', '26', '27', '28'],
    },
    group: 'dnevniPlanEmitovanjaZaKupca',
    inlineAdding: false,
    inlineEditing: false,
    lazyListSource: 'mainAndSecond',
    name: 'Main',
    relations: [],
  };

  // tslint:disable-next-line: member-ordering
  public Glink16Table = {
    additable: false,
    title: 'Maska 16 - Glink',
    type: 'main',
    _id: '213132332',
    allFields: [
      {
        additable: false,
        dbType: 'INTEGER',
        editable: false,
        fieldKey: 'RedniBroj',
        id: '20',
        label: 'Redni broj',
        mandatory: false,
        name: 'RedniBroj',
        type: 'input',
        width: 50,
        sortable: true,
      },
      {
        additable: false,
        dbType: 'INTEGER',
        editable: false,
        fieldKey: 'RedniBroj',
        id: '20',
        label: 'Redni broj',
        mandatory: false,
        name: 'RedniBroj',
        type: 'input',
        width: 50,
        sortable: true,
      },
      {
        additable: false,
        dbType: 'VARCHAR(10)',
        editable: false,
        fieldKey: 'SpotNaziv',
        id: '21',
        label: 'Naziv spota',
        mandatory: false,
        name: 'SpotNaziv',
        type: 'input',
        width: 100,
        sortable: true,
      },
      {
        additable: false,
        dbType: 'VARCHAR(100)',
        editable: false,
        fieldKey: 'SpotSifra',
        id: '22',
        label: 'Šifra spota',
        mandatory: false,
        name: 'SpotSifra',
        type: 'input',
        width: 50,
        sortable: true,
      },
      {
        additable: false,
        dbType: 'VARCHAR(100)',
        editable: false,
        fieldKey: 'Trajanje',
        id: '23',
        label: 'Trajanje (s)',
        mandatory: false,
        name: 'Trajanje',
        type: 'input',
        width: 50,
        sortable: true,
      },
      {
        additable: false,
        dbType: 'DECIMAL',
        editable: false,
        fieldKey: 'OsnovnaCena',
        id: '24',
        label: 'Osnovna cena',
        mandatory: false,
        name: 'OsnovnaCena',
        type: 'input',
        width: 100,
        sortable: true,
      },
      {
        additable: false,
        dbType: 'DECIMAL',
        editable: false,
        fieldKey: 'UkupanPopust',
        id: '25',
        label: 'Korekcija',
        mandatory: false,
        name: 'UkupanPopust',
        type: 'input',
        width: 100,
        sortable: true,
      },
      {
        additable: false,
        dbType: 'DECIMAL',
        editable: false,
        fieldKey: 'Procenat',
        id: '26',
        label: 'Korekcija (%)',
        mandatory: false,
        name: 'Procenat',
        type: 'input',
        width: 100,
        sortable: true,
      },
      {
        additable: false,
        dbType: 'DECIMAL',
        editable: false,
        fieldKey: 'VrednostRezervacije',
        id: '27',
        label: 'Vrednost rezervacije',
        mandatory: false,
        name: 'VrednostRezervacije',
        type: 'input',
        width: 100,
        sortable: true,
      },
      {
        additable: false,
        dbType: 'DECIMAL',
        editable: false,
        fieldKey: 'Fakturisano',
        id: '28',
        label: 'Fakturisano',
        mandatory: false,
        name: 'Fakturisano',
        type: 'input',
        width: 100,
        sortable: true,
      },
      {
        additable: false,
        dbType: 'VARCHAR(50)',
        editable: false,
        fieldKey: 'R',
        id: '29',
        label: 'R',
        mandatory: false,
        name: 'R',
        type: 'input',
        width: 30,
        sortable: true,
      },
      {
        additable: false,
        dbType: 'VARCHAR(50)',
        editable: false,
        fieldKey: 'EmisijaNaziv',
        id: '30',
        label: 'Naziv emisije',
        mandatory: false,
        name: 'EmisijaNaziv',
        type: 'input',
        width: 100,
        sortable: true,
      },
      {
        additable: false,
        dbType: 'NVARCHAR(20)',
        editable: false,
        fieldKey: 'Program',
        id: '31',
        label: 'Program',
        mandatory: false,
        name: 'Program',
        type: 'input',
        width: 100,
        sortable: true,
      },
      {
        additable: false,
        dbType: 'DATE',
        editable: false,
        fieldKey: 'DatumEmitovanja',
        id: '32',
        label: 'Datum emitovanja',
        mandatory: false,
        name: 'DatumEmitovanja',
        type: 'date',
        width: 100,
        sortable: true,
      },
    ],
    filterFields: [],
    completerMainAndSecond: false,
    deletable: false,
    documentType: 'izvestaj',
    editable: false,
    fetchObject: 'basic',
    formCode: 'M3_RPT2',
    formSettings: {
      table: [
        '20',
        '21',
        '22',
        '23',
        '24',
        '25',
        '26',
        '27',
        '28',
        '29',
        '30',
        '31',
        '32',
      ],
    },
    group: 'dnevniPlanEmitovanjaZaKupca',
    inlineAdding: false,
    inlineEditing: false,
    lazyListSource: 'mainAndSecond',
    name: 'Main',
    relations: [],
  };

  getRelationSettings(
    name: string,
    completerMainField: string,
    completerSecondField: string,
    lookupTable: Array<any>,
    allFields
  ) {
    return {
      additable: true,
      allFields,
      completerMainAndSecond: true,
      completerMainField,
      completerSecondField,
      deletable: true,
      details: [],
      documentType: 'Sifarnik',
      editable: true,
      fetchObject: 'basic',
      filterFields: [],
      formSettings: {
        header: [
          {
            title: 'Podaci',
            panels: [
              {
                title: 'Panel 1',
                panelVisible: false,
                expanded: true,
                controls: [[], []],
              },
            ],
          },
        ],
        table: [],
        lookupTable,
      },
      fromCode: '',
      group: name,
      idProperty: 'Id',
      inlineAdding: true,
      inlineEditing: true,
      lazyListSource: 'mainAndSecond',
      name,
      relations: [],
      title: name,
      type: name,
      _id: '51073157',
    };
  }

  getDatumOdSettings() {
    return {
      additable: true,
      dbType: 'BIGINT',
      default: true,
      editable: true,
      fieldKey: 'DatumOd',
      id: '555-555-555',
      javaFieldType: 'java.util.Date',
      label: 'Datum od',
      mandatory: false,
      name: 'DatumOd',
      path: null,
      type: 'date',
      width: 92,
    };
  }

  getDatumDoSettings() {
    return {
      additable: true,
      dbType: 'BIGINT',
      default: true,
      editable: true,
      fieldKey: 'DatumDo',
      id: '666-666-666',
      javaFieldType: 'java.util.Date',
      label: 'Datum do',
      mandatory: false,
      name: 'DatumDo',
      path: null,
      type: 'date',
      width: 92,
    };
  }

  getUgovorFieldSettings() {
    return {
      additable: true,
      dbType: 'VARCHAR(25)',
      default: true,
      editable: false,
      fieldKey: 'Ugovor',
      entityType: 'Ugovor',
      id: '111-111-111',
      label: 'Ugovor',
      lookupFormCode: 'MSUGO_UGO',
      lookupFormName: 'Pregled ugovora',
      mandatory: true,
      name: 'Ugovor',
      path: 'Glink.Ugovor',
      type: 'completer',
      width: 10,
    };
  }

  getPodugovorFieldSettings() {
    return {
      additable: true,
      dbType: 'VARCHAR(25)',
      default: true,
      editable: true,
      fieldKey: 'Podugovor',
      entityType: 'Podugovor',
      id: '444',
      label: 'Podugovor',
      lookupFormCode: 'MSUGO_PUGKLI',
      lookupFormName: 'Pregled podugovora',
      mandatory: true,
      name: 'Podugovor',
      path: 'Glink.Podugovor',
      type: 'completer',
      width: 10,
    };
  }

  getProgramFieldSettings() {
    return {
      additable: true,
      dbType: 'VARCHAR(25)',
      default: true,
      editable: false,
      fieldKey: 'ProgramIds',
      entityType: 'ProgramIdEnum',
      id: '222-222-222',
      label: 'Programi',
      lookupFormCode: null,
      lookupFormName: null,
      mandatory: false,
      name: 'ProgramIds',
      path: null,
      type: 'select',
      width: 10,
    };
  }

  getStatusRezervacijeGlinkSettings() {
    return {
      additable: true,
      dbType: 'VARCHAR(25)',
      default: true,
      editable: false,
      fieldKey: 'Status',
      entityType: 'StatusRezervacijeEnum',
      id: '090-090-090',
      label: 'Status',
      lookupFormCode: null,
      lookupFormName: null,
      mandatory: false,
      name: 'ProgramIds',
      path: null,
      type: 'select',
      width: 10,
    };
  }

  // tslint:disable-next-line: member-ordering
  public getGlinkHeader = {
    _id: '1555917011',
    title: 'Maska 16 - Glink',
    group: 'Glink',
    deletable: 'true',
    documentType: 'Sifarnik',
    fetchObject: 'basic',
    lazyListSource: 'mainAndSecond',
    fromCode: 'MSRR_GLINK',
    idProperty: '',
    completerMainField: '',
    completerSecondField: '',
    completerMainAndSecond: false,
    name: 'Glink',
    type: 'Glink',
    editable: true,
    additable: true,
    inlineAdding: true,
    inlineEditing: false,
    allFields: [
      this.getDatumOdSettings(),
      this.getDatumDoSettings(),
      this.getProgramFieldSettings(),
      this.getUgovorFieldSettings(),
      this.getPodugovorFieldSettings(),
      this.getStatusRezervacijeGlinkSettings(),
    ],
    filterFields: [],
    formSettings: {
      header: [
        {
          title: 'Podaci',
          panels: [
            {
              title: 'Klijent',
              panelVisible: true,
              expanded: true,
              controls: [
                [
                  this.getUgovorFieldSettings().id,
                  this.getDatumOdSettings().id,
                  this.getProgramFieldSettings().id,
                ],
                [
                  this.getPodugovorFieldSettings().id,
                  this.getDatumDoSettings().id,
                  this.getStatusRezervacijeGlinkSettings().id,
                ],
              ],
            },
          ],
        },
      ],
    },
    relations: [
      this.getRelationSettings(
        'Ugovor',
        'BrojUgovora',
        'PraviBrojUgovora',
        [this.getUgovorFieldSettings().id],
        [this.getUgovorFieldSettings()]
      ),
      this.getRelationSettings(
        'Podugovor',
        'BrojPodugovora',
        'KlijentNaziv',
        [this.getPodugovorFieldSettings().id],
        [this.getPodugovorFieldSettings()]
      ),
    ],
  };

  // tslint:disable-next-line: member-ordering
  public meseci: EnumItem[] = [
    {
      value: 1,
      label: 'Januar',
    },
    {
      value: 2,
      label: 'Februar',
    },
    {
      value: 3,
      label: 'Mart',
    },
    {
      value: 4,
      label: 'April',
    },
    {
      value: 5,
      label: 'Maj',
    },
    {
      value: 6,
      label: 'Jun',
    },
    {
      value: 7,
      label: 'Jul',
    },
    {
      value: 8,
      label: 'Avgust',
    },
    {
      value: 9,
      label: 'Septembar',
    },
    {
      value: 10,
      label: 'Oktobar',
    },
    {
      value: 11,
      label: 'Novembar',
    },
    {
      value: 12,
      label: 'Decembar',
    },
  ];

  // tslint:disable-next-line: member-ordering
  public statusRezervacije: EnumItem[] = [
    {
      value: 1,
      label: '1 - Nije emitovano',
    },
    {
      value: 2,
      label: '2 - Emitovano',
    },
    {
      value: 3,
      label: '3 - Planirano',
    },
  ];
}



// WEBPACK FOOTER //
// ./src/app/pages/izvestaji/prihodi-po-emisijama/izvestaj-settings.service.ts